import type { PageRoute } from '../../page-route';
import { HrList } from './page';

export const route: PageRoute = { path: '/hr', access: 'authed', Component: HrList };
